export const cibReverbnation = ["32 32","<path d='M32 12.432l-12.193-0.041-3.843-11.631-3.771 11.631-12.152 0.041 9.823 7.141-3.807 11.667h0.036l9.948-7.183 9.86 7.183-3.808-11.641 9.907-7.177z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-reverbnation.js
// module id = null
// module chunks = 